import React from 'react'
import Header from './includes/header'
import Sidebar from './includes/sidebar';
const Layout = ({ children }) => {
    return (
        <div id="layout-wrapper">
            <Header />
            <Sidebar />
            <div className="vertical-overlay"></div>
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Layout